// Datos de la sesión que solo existen en el browser y que el back no puede
// reconstruir después: el pago se confirma por un webhook de Mercado Pago, que
// llega cuando el alumno ya no está en la web (muchas veces nunca vuelve).
//
// Se mandan junto con la reserva para que queden guardados con ella y estén
// disponibles cuando se confirme. Son identificadores opacos para nosotros: no
// se interpretan acá ni se validan, solo se copian tal cual los dejó el pixel.
//
// Que falten es normal —el alumno puede bloquear cookies o entrar sin haber
// pasado por un anuncio— y no rompe nada: en ese caso no se manda el campo.
const TRACKED_COOKIE_NAMES = ['_fbp', '_fbc'];

const readCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));

  return match ? decodeURIComponent(match[1]) : undefined;
};

export const getTrackingInfo = (): Record<string, string> | undefined => {
  const trackingInfo = TRACKED_COOKIE_NAMES.reduce<Record<string, string>>((accumulator, name) => {
    const value = readCookie(name);

    if (value) {
      accumulator[name] = value;
    }

    return accumulator;
  }, {});

  return Object.keys(trackingInfo).length > 0 ? trackingInfo : undefined;
};
